import React from "react";
import "./detailsGrid.css";

const VehicleDetailsGrid = ({ title, bg, details, comments }) => {
  return (
    <section className={`dp-vgrid${bg ? " dp-vgrid--alt" : ""}`}>
      <h4 className="dp-vgrid__title">{title}</h4>
      {details ? (
        <div className="dp-vgrid__list">
          {details.map((key, index) => (
            <div key={`${key.name || "row"}-${index}`} className="dp-vgrid__row">
              <span className="dp-vgrid__label">{key.name}</span>
              <span className="dp-vgrid__value">
                {key.value === true
                  ? "Yes"
                  : key.value === false || key.value == null || key.value === ""
                  ? "—"
                  : String(key.value)}
              </span>
            </div>
          ))}
        </div>
      ) : null}
      {comments ? (
        <div className="dp-vgrid__comments">
          <p>{comments}</p>
        </div>
      ) : null}
    </section>
  );
};

export default VehicleDetailsGrid;
